export default __webpack_public_path__ + "static/media/Resolucion_30_acta_17_de_fecha_31_03_2022.35d15dd5.pdf";